export const MONTHS_ABBRS = [
  "Янв",
  "Фев",
  "Мар",
  "Апр",
  "Май",
  "Июн",
  "Июл",
  "Авг",
  "Сент",
  "Окт",
  "Нояб",
  "Дек",
] as const;
